import { defineComponent as _defineComponent } from 'vue'
import { computed, ComputedRef } from 'vue';

import BrandIcon from '@/components/icons/BrandIcon.vue';
import { useRoute, useRouter } from '@/composables/router/VueRouter';
import BrowserDetection from '@/data/BrowserDetection';
import { Track, TrackType } from '@/data/datatypes/Track';
import NonAppMenu from '@/NonAppMenu.vue';
import PrimaryMenu from '@/PrimaryMenu.vue';
import RouteNames from '@/router/RouteNames';
import { useTrackEntriesStore } from '@/stores/TrackEntries';
import { useTracksStore } from '@/stores/Tracks';
import { useUIStateStore } from '@/stores/UIState';

interface Emits {
  (e: 'clearAllNotifications'): void,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderBar',
  emits: ["clearAllNotifications"],
  setup(__props) {

const tracksStore = useTracksStore();
const trackEntriesStore = useTrackEntriesStore();
const uiStateStore = useUIStateStore();

const route = useRoute();
const router = useRouter();



const isMobile: ComputedRef<boolean> = computed(() => {
  return BrowserDetection.isMobile();
});

const showReturnToWorkspaceOverview: ComputedRef<boolean> = computed(() => {
  if (!isMobile.value) {
    return false;
  }
  if (route.name === RouteNames.TRACK_DASHBOARD_ROUTE_NAME) {
    return false;
  }
  if (!activeTrack.value) {
    return false;
  }
  // Check that we're in a child of the main track route
  let childRoute: boolean = false;
  for (const routeRecord of route.matched ?? []) {
    if (routeRecord.name === RouteNames.TRACK_MAIN_BASE_ROUTE_NAME) {
      childRoute = true;
    }
  }
  if (childRoute) {
    if (![TrackType.STANDARD, TrackType.BREAKOUT, TrackType.CHANNEL_CHAT].includes(activeTrack.value.type)) {
      childRoute = false;
    }
  }

  return childRoute;
});

function handleMobileHeaderClick(): void {
  const validTrackTypes = [TrackType.STANDARD, TrackType.BREAKOUT];
  if (activeTrack.value && validTrackTypes.includes(activeTrack.value.type)) {
    uiStateStore.setAdditionalContentVisible(!uiStateStore.showAdditionalContent);
  }
}

function returnToWorkspaceOverview(): void {
  if (trackEntriesStore.currentlyDisplayedFile) {
    trackEntriesStore.setCurrentlyDisplayedFile(null);
  }
  if (activeTrack.value) {
    router.push({
      name: RouteNames.TRACK_DASHBOARD_ROUTE_NAME,
      params: { trackId: activeTrack.value.id }
    });
  }
}

const activeTrack: ComputedRef<Track | undefined> = computed(() => {
  return tracksStore.activeTrack;
});

const mobileHeader: ComputedRef<string> = computed(() => {
  return activeTrack.value?.title ?? '';
});

const mobileHeaderToggleLabel: ComputedRef<string> = computed(() => {
  return `${uiStateStore.showAdditionalContent ? 'Hide' : 'Show'} details`;
});

return { __sfc: true,tracksStore, trackEntriesStore, uiStateStore, route, router, isMobile, showReturnToWorkspaceOverview, handleMobileHeaderClick, returnToWorkspaceOverview, activeTrack, mobileHeader, mobileHeaderToggleLabel, BrandIcon, NonAppMenu, PrimaryMenu }
}

})